import styled, { css } from 'styled-components';

export const MapContainer = styled.div`
  position: relative;
`;

export const ShowHideBtn = styled.button<{ isVisible: boolean }>`
  font: inherit;
  background: inherit;
  border: none;
  z-index: 2;
  position: relative;
  border: 1px solid ${({ theme }) => theme.backgroundLight};
  border-radius: 8px;
  padding: 8px;
  color: ${({ theme }) => theme.textLight};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isVisible }) =>
    isVisible
      ? css`
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
        `
      : ''}

  > :not(:last-child) {
    margin-right: 8px;
  }
`;
